import { FrontLogger } from "@whatslly/commons/frontLogger/frontLogger";

export class ApiError extends Error {
  public readonly status: number;
  constructor(
    message: string,
    public readonly response: Response
  ) {
    super(message);
    this.status = response.status;
  }
}

export const parseOrReturnError = async <T>(response: Response, logger: FrontLogger) => {
  try {
    if (response.ok) {
      return response.json() as Promise<T>;
    } else if (response.headers.get("content-type")?.includes("application/json")) {
      const { error } = await response.json();
      throw new ApiError(`${error ?? "Unknown error"}: ${response.status}`, response);
    }
    throw new ApiError(`Unknown error: ${response.status}`, response);
  } catch (error) {
    logger.error({ err: error }, "Error on dashboard request");
    throw error;
  }
};
